import { MenuItem } from 'primeng/api';

export const SIDEBAR_ITEMS: MenuItem[] = [
  {
    label: 'sidebar.formBuilder',
    icon: 'heroDocumentText',
    routerLink: ['/form-builder'],
  },
  {
    label: 'sidebar.incidentSubmissions',
    icon: 'heroClipboardDocumentList',
    routerLink: ['/incident-submissions'],
  },
  {
    label: 'sidebar.avoidedIncidents',
    icon: 'heroShieldCheck',
    routerLink: ['/avoided-incidents'],
  },
  {
    label: 'sidebar.operators',
    icon: 'heroUsers',
    routerLink: ['/operators'],
  },
  {
    label: 'sidebar.companies',
    icon: 'heroBuildingOffice',
    routerLink: ['/companies'],
  },
  {
    label: 'sidebar.activityLogs',
    icon: 'heroPresentationChartBar',
    routerLink: ['/activity-logs'],
  },
];
